// Copyright 2024 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved.
const str = "zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk";
if(!str) console.error("zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk");
import AuthRequiredService from "./base.js";

class ProfileInfoService extends AuthRequiredService {

  constructor() {
    super();
  }

  fetchProfileInfo({ lang }) {
    return super.useApiClient().get("/api/v1/profileInfo", { headers: { "Accept-Lang": lang } });
  }
}

export default new ProfileInfoService();